import { render, staticRenderFns } from "./SvgArrowRightSmall.vue?vue&type=template&id=12ad6d76&"
import script from "./SvgArrowRightSmall.vue?vue&type=script&lang=js&"
export * from "./SvgArrowRightSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports